import Model from "@/lib/model/model";
import request from "@/lib/request/request";
import { QuestionV2 } from "@/lib/model/exambuilder/question-v2";
import { NonessentialComponent } from "@/lib/model/exambuilder/exam-component/common";

export class ThousandsQsJob extends Model {
  title = "";
  scene = 2;
  duty = "";
  description = "";
}

export class ThousandsTaskList extends Model {
  questionId = 0;
  dimensionKey = "";
}

export class ThousandsQsSearch extends Model {
  jobConfig = new ThousandsQsJob();
  taskList: ThousandsTaskList[] = [];

  get() {
    return request
      .postInterviewApi("hr/ai/thousandsTask", {
        jobConfig: this.jobConfig,
        taskList: this.taskList
      })
      .then(res => {
        if (res.data.code !== 0) return [];

        return res.data.data.thousandsDescList;
      });
  }

  public objectArrayClasses() {
    return {
      taskList: ThousandsTaskList
    };
  }
}

export class ThousandsQuestion extends Model {
  question = new QuestionV2();
  thousandsDescList = [""];
  selectedIndex = 0;

  change() {
    this.selectedIndex++;

    if (this.selectedIndex >= this.thousandsDescList.length) {
      this.selectedIndex = 0;
    }
  }
}

export class ThousandsDesc extends Model {
  questionId = 0;
  thousandsDesc = "";
}

export class ThousandsComponent extends NonessentialComponent {
  jobConfig = new ThousandsQsJob();
  thousandsDescList: ThousandsDesc[] = [];

  // 前端字段 - 暂存字段
  thousandsQuestion: ThousandsQuestion[] = []; // 千人千问生成的字段
  questions: number[] = []; // 参与生成千人千问的题目

  public objectArrayClasses() {
    return {
      thousandsDescList: ThousandsDesc,
      questions: 0,
      thousandsQuestion: ThousandsQuestion
    };
  }
}

export class ThousandsTaskItem extends Model {
  questionId = 0;
  questionDesc = "";
  thousandsQuestionDesc = "";
}

export class ThousandsTask extends Model {
  list: ThousandsTaskItem[] = [];

  public objectArrayClasses() {
    return {
      list: ThousandsTaskItem
    };
  }

  createTask() {
    return request
      .postInterviewApi("hr/exam/thousands/generate", {
        list: this.list
      })
      .then(res => {
        if (res.data.code !== 0) return 0;

        return res.data.data.taskId;
      });
  }

  get(id: string) {
    return request
      .postInterviewApi("public/exam/thousands/query", {
        taskId: id
      })
      .then(res => {
        if (res.data.code !== 0) return 0;

        return res.data.data;
      });
  }
}
